import React from "react";
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Icon,
  Text,
} from "@chakra-ui/react";
import VeriHeading from "../VeriHeading";
import { BellIcon, CloseIcon } from "./Icons";

const NotificationList = ({ notifications }) => {
  if (!notifications || notifications.length === 0) {
    return (
      <Flex
        mt={{ base: "32px", md: "64px" }}
        justifyContent="center"
        textAlign="center"
      >
        <Box>
          <Flex justifyContent="center">
            <Box bg="bg.lighter" borderRadius="50%">
              <Icon
                as={BellIcon}
                m="32px"
                color="icons.grey"
                boxSize={"48px"}
              />
            </Box>
          </Flex>
          <VeriHeading mt="24px" textStyle="h5">
            No notifications yet
          </VeriHeading>
          <Text>Notifications about new activity will show up here.</Text>
        </Box>
      </Flex>
    );
  }

  return <></>;
};

const NotificationsDrawer = ({ notifications, isOpen, onClose, ...rest }) => {
  return (
    <>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} {...rest}>
        <DrawerOverlay>
          <DrawerContent>
            <Flex
              px="24px"
              alignItems="center"
              justifyContent="space-between"
              h="76px"
              borderBottomWidth="1px"
              borderBottomColor="border.input"
            >
              <VeriHeading as="h5" textStyle="h5">
                Notifications
              </VeriHeading>
              <Icon
                cursor="pointer"
                onClick={onClose}
                as={CloseIcon}
                boxSize="24px"
              />
            </Flex>
            <DrawerBody>
              <NotificationList notifications={notifications} />
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </>
  );
};

export default NotificationsDrawer;
